import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar 
  ,IonGrid, IonModal, IonBackButton, IonThumbnail
  ,IonRow, IonCard , IonCardSubtitle, IonCardTitle, IonCardContent
  ,IonCol, IonItemOptions, IonItemOption, IonImg, IonCardHeader, IonItemDivider, IonAlert
  ,IonListHeader, IonToggle, IonRadio, IonCheckbox, IonItemSliding, IonIcon, IonFooter, IonSegment, IonSegmentButton
,IonAccordionGroup, IonAccordion} from '@ionic/react';

import { close, checkmark, qrCodeOutline, arrowRedo, chevronBack, closeCircle  } from 'ionicons/icons';
import React, { useState, useEffect, Component } from 'react';
//import { useParams } from 'react-router';
import './DarHistory.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import QrReader from 'react-qr-reader'
import ServerService from '../../../services/Server';

const DarHistory: React.FC = () => {
const server = new ServerService();
const name:string = "B1-DAR History";
const now = new Date();
const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();
const [showQrScan, setShowQrScan] = useState(true);
const [showDetail, setShowDetail] = useState(false);
const [showMsg, setShowMsg] = useState(false);
const [qrReader, setQrReader] = useState("");
const [barCode, setBarcode] = useState("");
const [docName, setDocName] = useState("");
const [docNo, setDocNo] = useState("");
const [revision, setRevision] = useState("");
const [laseRevision, setLaseRevision] = useState("");
const [effectiveDate, setEffectiveDate] = useState("");
const [expireDate, setExpireDate] = useState("");
const [routeName, setRouteName] = useState("");
const [darNo, setDarNo] = useState("");
const [listDar, setListDar] = useState([]);
const onScanQr = function(status:any) {
  setShowQrScan(false);
}
const onClickBarcodeQR = function(qr:any) {
  fetchDoc(qr);
}
const onClickBarcode = function(status:any) {
  
 var result =  fetchDoc(barCode);

}
const handleScan = (data: any) => {
  if (data!=null && data != '') {
   setShowQrScan(true);
   setBarcode(data);
   onClickBarcodeQR(data);
  
  }
}
const handleError = (err: any) => {
  console.error(err)
 }

 const fetchDoc = async function(no:any) {
  const data = {
    no: no
  }
   await fetch(server.getFullUrl("rp/getDocByNo", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
       if(result.success){
        fetchDarInfo(result);
       }else{
        setShowDetail(false);
        setShowMsg(true);
       }
   
     
    },
    (error) => {
     
    }
 ).catch(e => {

 })
).catch(e => {

})
 
}

 const fetchDarInfo = async function(resultDoc:any) {
  const data = {
    docNo: resultDoc.data.id
  }
   await fetch(server.getFullUrl("rp/listDarDoc", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {

      setListDar(result.data);
      setShowDetail(true);
      setShowMsg(false);
     
    },
    (error) => {
     
    }
 ).catch(e => {

 })
).catch(e => {

})
 
}

const showDarDetail = function(){
  if(showDetail){
    return (
      <IonAccordionGroup>
       {listDar.map((dar, index) => (
         <IonAccordion value={dar} key={index}>
         <IonItem slot="header" color="light">
           <IonLabel>Dar No : {dar.dar_no}</IonLabel>
         </IonItem>
         <div className="ion-padding" slot="content">
          <div className="item_newline">
          <div className="item_h_detail">Document Name : <span className="item_detail">{dar.name}</span></div>
          <div className="item_h_detail">Document No : <span className="item_detail">{dar.doc_no}</span></div>
          <div className="item_h_detail">Version :  <span className="item_detail">{dar.version}</span></div>
          <div className="item_h_detail">Effective Date :  <span className="item_detail">{dar.effective_date}</span></div>
          <div className="item_h_detail">Document Type :  <span className="item_detail">{dar.doctypename}</span></div>
          <div className="item_h_detail">Action Type :  <span className="item_detail">{dar.action}</span></div>
          <div className="item_h_detail">Reason :  <span className="item_detail">{dar.remark}</span></div>
        </div>
         </div>
       </IonAccordion>
        ))}
     
    </IonAccordionGroup>
    )
    }
}

const showDarMsg = function(){
  if(showMsg){
    return (
      <IonCard>   
        <IonCardHeader>
        <IonCardTitle>Document not found.</IonCardTitle>
      </IonCardHeader>
      </IonCard>   
    )
  }
 
}

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonModal isOpen={!showQrScan}>
      <IonListHeader>
      <IonLabel>Scan QR Code</IonLabel>
      <IonButton onClick={() => setShowQrScan(true)}><IonIcon icon={closeCircle}></IonIcon></IonButton>
      </IonListHeader>
    
        <IonContent>
        
        <div hidden={showQrScan}>
          <QrReader
            delay={1000}
            onError={handleError}
            onScan={handleScan}
            resolution={1200}
            style={{ width: '100%' }}
          />
        </div>
        </IonContent>
      </IonModal>

        <IonList>
        <IonItem>
            <IonLabel className="f-header p1" position="stacked">Doc Number</IonLabel>
            <IonInput value={barCode} onIonChange={e => {setBarcode(e.detail.value)}}> </IonInput>
          </IonItem>
        </IonList>
        <IonGrid>
  <IonRow>
    <IonCol>
      <IonButton color="secondary" expand="block" onClick={(e) => onScanQr("")}><IonIcon icon={qrCodeOutline}></IonIcon> <IonLabel>Scan QR</IonLabel></IonButton>
    </IonCol>
    <IonCol>
    <IonButton color="primary" expand="block" onClick={(e) => onClickBarcode("")}><IonIcon icon={arrowRedo}></IonIcon>Submit</IonButton>
    </IonCol>
  </IonRow>
</IonGrid>
           {showDarMsg()}
           {showDarDetail()}
      </IonContent>
     
    </IonPage>
  );
};

export default DarHistory;
